var discountUTM = [
    {
        code: 'MA20SOGG',
        discount: 20,
        type:['Hawaiian Shirt','Tumbler', 'Cap', 'Car Visor Clip', 'Bookmark', 'Pillow', 'Whiskey Glass', 'Window Hanging Suncatcher', 'Shirt', 'Toiletry Bag',
        'Tote Bag', 'Sweatpants', 'Sweater', 'Sweatshirt', 'Shorts', 'Night Light', 'Jewelry Dish', 'Backdrop', 'Plant Pot', 'Mug', 'Magnet', 'Socks'
        ],
        scope: 'country',
        countries: ['US'],
        ads:'google'
    },
    {
        code: 'DCGG30',
        discount: 30,
        type: ['Doormat','Metal Sign','Garden Stone','Suncatcher'],
        scope: 'country',
        countries: ['US'],
        ads:'google'
    },
    {
        code: 'DC50OR',
        discount: 30,
        type: ['Ornament'],
        scope: 'country',
        countries: ['US'],
        ads:'google'
    },
    {
        code: 'UK2026',
        discount: 20,
        type:null, 
        scope: 'country',
        countries: ['GB'],
        ads:'google'
    },
    {
        code: 'AU10GG',
        discount: 10,
        type: ['Lounge Pants', 'Bookmark', 'Toiletry Bag', 'Sweater', 'Sweatshirt'],
        scope: 'country',
        countries: ['AU'],
        ads:'google'
    },
    {
        code: 'AU18GGFF',
        discount: 18,
        type: ['Beach Towel', 'Cap', 'Doormat', 'Jewelry Dish', 'Metal Sign', 'Pillow', 'Poster', 'Puzzle', 'Shirt', 'Tumbler', 'Whiskey Glass', 'Window Hanging Suncatcher', 'Wood Sign', 'Wooden Plaque', 'Acrylic Plaque',
            'Desk Mat', 'Desk Clock'
        ],
        scope: 'country',
        countries: ['AU'],
        ads:'google'
    },
    {
        code: 'GG25AU',
        discount: 25,
        type: ['Blanket', 'Car Visor Clip', 'Hawaiian Shirt', 'Leather Belt', 'Mug', 'Night Light'],
        scope: 'country',
        countries: ['AU'],
        ads:'google'
    },
    {
        code: 'CA10GG',
        discount: 10,
        type: null,
        scope: 'country',
        countries: ['CA'],
        ads:'google'
    },
    {
        code: 'RM20GG',
        discount: 20,
        type: null,
        scope: 'country',
        countries: ['US'],
        ads:'google'
    },
    {
        code: 'BF50FB',
        discount: 50,
        collection:['Personalized Blanket'],
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'BF42FB',
        discount: 50,
        collection:['Holiday Ornaments'],
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'BF53FB',
        discount: 53,
        collection:['Holiday Ornaments'],
        ads:'meta',
        scope: 'global',
        isCustom:true,
    },
    {
        code: 'PONM',
        discount: 65,
        collection:['Holiday Ornaments'],
        ads:'meta',
        scope: 'global',
    },
    {
        code: 'BF30FB',
        discount: 20,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'BFCM',
        discount: 30,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'BF10FB',
        discount: 10,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'BF20FB',
        discount: 20,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'FB10',
        discount: 10,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'FB20',
        discount: 20,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'CS25',
        discount: 25,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'BF25FB',
        discount: 25,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'BF51FB',
        discount: 51,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'MTS34',
        discount: 34,
        collection:['Metal Sign'],
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'HT30',
        discount: 30,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'TP20',
        discount: 20,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'HB10',
        discount: 10,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'GAGGIFT',
        discount: 50,
        collection:['Funny T-Shirt Gag Gifts — Limited Discount!'],
        scope: 'global',
        ads:'meta'
    },
    {
        code: 'HLW20',
        discount: 20,
        collection:null,
        scope: 'global',
        ads:'meta'
    },
]
const CAMPAIGN_ADS_GOOGLE =[
    21047190149,
    23297977638,
    23277787320,
    20877453289,
    23357105932,
    23357123020,
    20839862361,
    23364328009,
    23256396653
]
const TYPE_NOT_BFCM = ['Mug', 'Shirt With Design On Sleeve', 'Shirt', 'Custom Print Hoodie','Comfort Tee','Poster','Gift Card','Tumbler Cup','Jewelry Dish','Square Jewelry Dish_FULL'];
const PRODUCT_ID_NOT_BFCM = [8653360660636,8649616261276]
const PRODUCT_ID_BFCM = [
    8572847030428,
    8652684689564,
    8650815635612,
    8568679530652,
    8307431800988,
    8658929254556,
    8604791963804,
    8653380976796, 
    8291106750620,
    8638111744156,
    8667892580508,
    8681830219932,
    8552602206364,
    8559590506652,
    8670292770972,
    8638358749340,
    8643326378140,
    8648045756572,
    7905587298460,
    8662356131996,
    8668904947868,
    8677407260828,
    8668909011100,
    8668900851868,
    7905764311196,
    8682060284060,
    8667892580508,
    8653306429596,
    8292586127516,
    8305064050844
];
const svgCopy = `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 1024 1024">
                      <path fill="#fff" d="M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64h64z"></path>
                      <path fill="#fff" d="M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H384zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64z"></path>
                    </svg>`;

function getCurrentLATime() {
    const now = new Date();
    // Convert current time to America/Los_Angeles timezone
    const laTimeString = now.toLocaleString("en-US", {
        timeZone: "America/Los_Angeles",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false
    });

    // Parse lại thành date object
    const [month, day, year] = laTimeString.split(',')[0].split('/');
    const [hour, minute, second] = laTimeString.split(',')[1].split(':');

    return new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day),
        parseInt(hour),
        parseInt(minute),
        parseInt(second)
    ).getTime();
}
function getNextMidnightLATime() {
    const now = getCurrentLATime();

    const nextMidnight = new Date(now);
    nextMidnight.setDate(nextMidnight.getDate() + 1);
    nextMidnight.setHours(0, 0, 0, 0);

    return nextMidnight.getTime();
}

function countdownUTM() {
    let timer;
    let targetTime = getNextMidnightLATime();

    function updateCountdown() {
        const now = getCurrentLATime();
        let totalSeconds = Math.floor((targetTime - now) / 1000);

        if (totalSeconds <= 0) {
            targetTime = getNextMidnightLATime();
            totalSeconds = Math.floor((targetTime - now) / 1000);
        }

        const hours = Math.floor((totalSeconds / (60 * 60)) % 24);
        const minutes = Math.floor((totalSeconds / 60) % 60);
        const seconds = Math.floor((totalSeconds) % 60);

        const h = document.getElementById('h');
        const m = document.getElementById('m');
        const s = document.getElementById('s');

        if (h) h.textContent = String(hours).padStart(2, '0');
        if (m) m.textContent = String(minutes).padStart(2, '0');
        if (s) s.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    timer = setInterval(updateCountdown, 1000);
}

function showDiscountHeader(
  code,
  discount = 0,
  showCountdown = true,
  price = 0,
  items = 0
) {
  const COUNTRY_CODE = document.body.getAttribute('country-code');
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;
  const freeShipHtml = COUNTRY_CODE === 'GB' ? `<span class="promotion-bar__free-ship text-title-s-bold">Free shipping on all orders</span>` : '';
  const countdownHtml = showCountdown
    ? `
      <span class="promotion-bar__countdown text-label-s-bold" id="countdown">
        <span id="h">00</span> : <span id="m">39</span> : <span id="s">59</span>
      </span>
    `
    : '';
  const iconHtml = `
    <span class="promotion-bar__star">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M5.17888 0.65267C5.50104 -0.217948 6.73242 -0.217948 7.05458 0.65267L8.11743 3.52497C8.21872 3.79869 8.43453 4.0145 8.70825 4.11579L11.5805 5.17863C12.4512 5.50079 12.4512 6.73218 11.5805 7.05434L8.70825 8.11719C8.43453 8.21847 8.21872 8.43428 8.11743 8.708L7.05458 11.5803C6.73242 12.4509 5.50104 12.4509 5.17888 11.5803L4.11603 8.708C4.01475 8.43428 3.79894 8.21847 3.52522 8.11719L0.652915 7.05434C-0.217704 6.73218 -0.217704 5.50079 0.652914 5.17864L3.52522 4.11579C3.79893 4.0145 4.01475 3.79869 4.11603 3.52497L5.17888 0.65267Z" fill="url(#paint0_linear_3302_41162)"/>
            <defs>
                <linearGradient id="paint0_linear_3302_41162" x1="14.1151" y1="6.11648" x2="-1.88159" y2="6.11648" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF8245"/>
                <stop offset="1" stop-color="#FF3300"/>
                </linearGradient>
            </defs>
        </svg>
    </span>
  `;

  const bulkContentHtml = items > 0 && price > 0
    ? `Buy ${items}+, from $${price} each with`
    : '';

  const html = `
    <div class="promotion-bar">
      <div class="promotion-bar__inner">
        ${iconHtml}
        <div class="promotion-bar__content-wrapper">
          ${freeShipHtml}

          <div class="promotion-bar__content">
            ${items > 0 && price > 0 ? '' : (COUNTRY_CODE !== 'GB' ? `<span class="promotion-bar__sale text-title-s-bold">Holiday Sale Up To ${discount ? `50% OFF` : ''}</span>` : '')}

            <div class="promotion-bar__actions">
              ${countdownHtml}

              <span class="promotion-bar__code text-title-s-bold">
                ${bulkContentHtml}
                ${items <= 0 || price <= 0 ? (COUNTRY_CODE === 'GB' ? `<span class="promotion-bar__sale text-title-s-bold">${discount ? `${discount}%` : ''}</span>` : '') : ''}
                ${items <= 0 || price <= 0 ? (COUNTRY_CODE === 'GB' ? 'off with' : 'Use code') : ''}
                <span class="promotion-bar__code-value">${code}</span>
              </span>

              <button class="promotion-bar__copy copy-discount text-label-xs-medium" type="button">
                Copy
              </button>
            </div>
          </div>
        </div>
        ${iconHtml}
      </div>

      <div id="toast" class="toast">Code copied!</div>
    </div>
  `;

  headerWrapper.insertAdjacentHTML('afterbegin', html);
}

function showDiscountFreeShipHeader() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  const iconHtml = `
    <span class="promotion-bar__star">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M5.17888 0.65267C5.50104 -0.217948 6.73242 -0.217948 7.05458 0.65267L8.11743 3.52497C8.21872 3.79869 8.43453 4.0145 8.70825 4.11579L11.5805 5.17863C12.4512 5.50079 12.4512 6.73218 11.5805 7.05434L8.70825 8.11719C8.43453 8.21847 8.21872 8.43428 8.11743 8.708L7.05458 11.5803C6.73242 12.4509 5.50104 12.4509 5.17888 11.5803L4.11603 8.708C4.01475 8.43428 3.79894 8.21847 3.52522 8.11719L0.652915 7.05434C-0.217704 6.73218 -0.217704 5.50079 0.652914 5.17864L3.52522 4.11579C3.79893 4.0145 4.01475 3.79869 4.11603 3.52497L5.17888 0.65267Z" fill="url(#paint0_linear_3302_41162)"/>
            <defs>
                <linearGradient id="paint0_linear_3302_41162" x1="14.1151" y1="6.11648" x2="-1.88159" y2="6.11648" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF8245"/>
                <stop offset="1" stop-color="#FF3300"/>
                </linearGradient>
            </defs>
        </svg>
    </span>
  `;

  const html = `
    <div class="promotion-bar">
      <div class="promotion-bar__inner">
        ${iconHtml}
        <div class="promotion-bar__content-wrapper">
          <span class="promotion-bar__free-ship text-title-s-bold">Free shipping on all orders</span>
        </div>
        ${iconHtml}
      </div>
    </div>
  `;

  headerWrapper.insertAdjacentHTML('afterbegin', html);
}

function showDiscountHeaderSiteWide(
  discount = 0,
  showCountdown = true,
  price = 0,
  items = 0
) {
  const COUNTRY_CODE = document.body.getAttribute('country-code');
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;
  const freeShipHtml = COUNTRY_CODE === 'GB' ? `<span class="promotion-bar__free-ship text-title-s-bold">Free shipping on all orders</span>` : '';
  const countdownHtml = showCountdown
    ? `
      <span class="promotion-bar__countdown text-label-s-bold" id="countdown">
        <span id="h">00</span> : <span id="m">39</span> : <span id="s">59</span>
      </span>
    `
    : '';
  const iconHtml = `
    <span class="promotion-bar__star">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M5.17888 0.65267C5.50104 -0.217948 6.73242 -0.217948 7.05458 0.65267L8.11743 3.52497C8.21872 3.79869 8.43453 4.0145 8.70825 4.11579L11.5805 5.17863C12.4512 5.50079 12.4512 6.73218 11.5805 7.05434L8.70825 8.11719C8.43453 8.21847 8.21872 8.43428 8.11743 8.708L7.05458 11.5803C6.73242 12.4509 5.50104 12.4509 5.17888 11.5803L4.11603 8.708C4.01475 8.43428 3.79894 8.21847 3.52522 8.11719L0.652915 7.05434C-0.217704 6.73218 -0.217704 5.50079 0.652914 5.17864L3.52522 4.11579C3.79893 4.0145 4.01475 3.79869 4.11603 3.52497L5.17888 0.65267Z" fill="url(#paint0_linear_3302_41162)"/>
            <defs>
                <linearGradient id="paint0_linear_3302_41162" x1="14.1151" y1="6.11648" x2="-1.88159" y2="6.11648" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF8245"/>
                <stop offset="1" stop-color="#FF3300"/>
                </linearGradient>
            </defs>
        </svg>
    </span>
  `;

  const bulkContentHtml = items > 0 && price > 0
    ? `Buy ${items}+, from $${price} each with`
    : '';

  const code = "HD2026";
  const html = `
    <div class="promotion-bar">
      <div class="promotion-bar__inner">
        ${iconHtml}
        <div class="promotion-bar__content-wrapper">
          ${freeShipHtml}

          <div class="promotion-bar__content">
            ${items > 0 && price > 0 ? '' : (COUNTRY_CODE !== 'GB' ? `<span class="promotion-bar__sale text-title-s-bold">SALE UP TO 50% OFF HOME DECOR</span>` : '')}

            <div class="promotion-bar__actions">
              ${countdownHtml}

              <span class="promotion-bar__code text-title-s-bold">
                ${bulkContentHtml}
                ${items <= 0 || price <= 0 ? (COUNTRY_CODE === 'GB' ? `<span class="promotion-bar__sale text-title-s-bold">${discount ? `${discount}%` : ''}</span>` : '') : ''}
                ${items <= 0 || price <= 0 ? (COUNTRY_CODE === 'GB' ? 'off with' : 'Use code') : ''}
                <span class="promotion-bar__code-value">${code}</span>
              </span>

              <button class="promotion-bar__copy copy-discount text-label-xs-medium" type="button">
                Copy
              </button>
            </div>
          </div>
        </div>
        ${iconHtml}
      </div>

      <div id="toast" class="toast">Code copied!</div>
    </div>
  `;

  headerWrapper.insertAdjacentHTML('afterbegin', html);
  countdownUTM();
  document.addEventListener('click', function (e) {
    if (e.target.closest('.copy-discount')) {
      navigator.clipboard.writeText(code).then(function () {
        showToast('Code copied!');
      });
    }
  });

}